import "./Advantage.css";
import experienceIcon from "../../../image/experience-icon.svg";
import trainingIcon from "../../../image/training-icon.svg";
import synopsisIcon from "../../../image/synopsis-icon.svg";
import calendarIcon from "../../../image/calendar-icon.svg";
import messageIcon from "../../../image/message-icon.svg";
import paymentIcon from "../../../image/payment-icon.svg";
import refundIcon from "../../../image/refund-icon.svg";

function Advantage() {
  return (
    <section className="advantage">
      <h2 className="skills__title skills__title_advantage">
        Обучение у нас – это удобно и результативно
      </h2>
      <ul className="advantage-list">
        <li className="advantage-list__block">
          <img
            className="advantage-list__img"
            src={experienceIcon}
            alt="иконка"
          />

          <h3 className="advantage-list__title">Много практики</h3>
          <p className="advantage-list__description">
            Задания и проекты, приближенные к реальной работе
          </p>
        </li>
        <li className="advantage-list__block">
          <img
            className="advantage-list__img"
            src={trainingIcon}
            alt="иконка"
          />
          <h3 className="advantage-list__title">
            Современные методики обучения
          </h3>
          <p className="advantage-list__description">
            Спиральное обучение: погружаемся в материал постепенно, виток за
            витком
          </p>
        </li>
        <li className="advantage-list__block">
          <img
            className="advantage-list__img"
            src={synopsisIcon}
            alt="иконка"
          />
          <h3 className="advantage-list__title">
            Простое и понятное изложение
          </h3>
          <p className="advantage-list__description">
            Вместо заумных терминов – примеры из реального мира
          </p>
        </li>
        <li className="advantage-list__block">
          <img
            className="advantage-list__img"
            src={calendarIcon}
            alt="иконка"
          />
          <h3 className="advantage-list__title">Гибкий график занятий</h3>
          <p className="advantage-list__description">
            Учитесь в любое время в удобном для вас темпе
          </p>
        </li>
        <li className="advantage-list__block">
          <img className="advantage-list__img" src={messageIcon} alt="иконка" />
          <h3 className="advantage-list__title">
            Прямая связь с опытными наставниками
          </h3>
          <p className="advantage-list__description">
            Задавайте вопросы и отправляйте свою работу на проверку
          </p>
        </li>
        <li className="advantage-list__block">
          <img className="advantage-list__img" src={paymentIcon} alt="иконка" />

          <h3 className="advantage-list__title">Оплата небольшими частями</h3>
          <p className="advantage-list__description">
            Платите только за тот материал, который сейчас изучаете, а не за
            весь курс сразу
          </p>
        </li>
        <li className="advantage-list__block">
          <img className="advantage-list__img" src={refundIcon} alt="иконка" />
          <h3 className="advantage-list__title">Быстрый и легкий возврат</h3>
          <p className="advantage-list__description">
            Если передумаете учиться – вернем деньги
          </p>
        </li>
      </ul>
    </section>
  );
}

export default Advantage;
